import axios from 'axios';
import { ROOT_URL } from '../globals';

export const FETCH_ACCT_ITEMS_BEGIN   = 'FETCH_ACCT_ITEMS_BEGIN';
export const FETCH_ACCT_ITEMS_SUCCESS = 'FETCH_ACCT_ITEMS_SUCCESS';
export const FETCH_ACCT_ITEMS_FAILURE = 'FETCH_ACCT_ITEMS_FAILURE';

export const fetchAcctItemsBegin = () => ({
    type: FETCH_ACCT_ITEMS_BEGIN
  });
  
  export const fetchAcctItemsSuccess = AcctItems => ({
    type: FETCH_ACCT_ITEMS_SUCCESS,
    payload:  AcctItems 
  });
  
  export const fetchAcctItemsFailure = error => ({
    type: FETCH_ACCT_ITEMS_FAILURE,
    payload: error
  });
  
  export default function fetchAccountItems(acctId) {
    return dispatch => {
      const url = `${ROOT_URL}Items/GetItemList/?acctId=${acctId}`;
      dispatch(fetchAcctItemsBegin())
      axios.get(url)
        .then (function(result) {
            dispatch(fetchAcctItemsSuccess(result));
            return result;
      })
      .catch(error => dispatch(fetchAcctItemsFailure(error)));
    };
  }
  


// WEBPACK FOOTER //
// ./src/actions/item_actions.js